/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { graphql, useStaticQuery } from "gatsby"
import styled from '@emotion/styled';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import SectionHeadline from '../../../components/SectionHeadline';
import AnimatedSection from '../../../components/AnimatedSection';
import { useLocalization } from "gatsby-theme-i18n";
import GuestList from '../../../components/GuestList';


const GuestSection = () => {

  const { t } = useLocalization();

  const { guestList } = useStaticQuery(graphql`
    query GuestSection {

      guestList : allGuest(
        filter: {data: {status: {eq: "publish"}}}
        sort: {fields: order, order: ASC}
      ) {
        edges {
          node {
            order
            name {
              ...localizedContent
            }
            title {
              ...localizedContent
            }
            tooltip {
              ...localizedContent
            }
            image {
              childImageSharp {
                gatsbyImageData(
                  quality: 90
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
            thumb {
              childImageSharp {
                gatsbyImageData(
                  quality: 90
                  layout: FULL_WIDTH
                  placeholder: NONE
                )
              }
            }
          }
        }
      }


    }
  `)

  return (
    <SectionWrapper id={`section_guest`} className={`guestList`}>
      <AnimatedSection>
        <Content css={css`
          max-width:calc(1440px + 96px);

          @media only screen and (max-width: ${breakpoint.smMax}){
            padding:0 80px;
          }

          @media only screen and (max-width: ${breakpoint.xsMax}){
            padding:0 24px;
          }
        `}>
          <WhiteCard>
            <SectionHeadline title={t('guest.guests.title')} category={t('guest.guests.subtitle')} />
            <GuestList list={guestList.edges} type={'section'}/>
          </WhiteCard>
        </Content>
      </AnimatedSection>
    </SectionWrapper>
  );
}
 
export default GuestSection;

const WhiteCard = styled.div`
  background: #FCFCFF;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  padding: 96px 0px;
  text-align:center;
  margin:0 auto;
  max-width: calc(100% - 96px);

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 0;
    max-width: none;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:32px 8px;
  }
`

const SectionWrapper = styled.div`
  background:#F7F7FA;
  display:flex;
  align-items:center;
  position:relative;
  padding:96px 0;
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 0;
    min-height:728px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    
    padding:32px 0;
    min-height:0;
  }
  
`;
const Content = styled.div`
  width:100%;
  margin:0 auto;
  position:relative;
  border-radius: 4px;
  overflow:hidden;
  z-index:5;
  max-width: calc(960px + 96px);
`
